import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as StateLib from "@/Utils/StateLib";
import { Breadcrumb } from "@theorgchartdev/storybook";
import cx from "classnames";
import { ReRenderCanvas } from "@/Utils/StateLib";
import { enumObjectTypes } from "@coreapp/constants";
import { BoxChip } from "@/Utils/BoxChip";

const crumbClick = targetID => {
  const wsMgr = StateLib.GetWSMgr();
  const cmdElement = {};
  cmdElement["targetID"] = targetID;
  wsMgr.DoNavToBox(cmdElement, true, undefined, false, true);
  ReRenderCanvas();
};

const getBreadcrumbs = (currentSubchart, cachedCrumbs, maxCrumbs) => {
  if (!currentSubchart) return [];

  let currentTopBox = currentSubchart.fTopDBObj;
  if (!currentTopBox) return [];
  const breadCrumbs = [currentTopBox];

  let topBoxCrumb = null;

  if (cachedCrumbs) {
    for (let i = 0; i < cachedCrumbs.length; i++) {
      topBoxCrumb = cachedCrumbs[i];
      if (currentTopBox == topBoxCrumb) return cachedCrumbs;
      topBoxCrumb = null;
    }
  }

  while (currentTopBox.GetParent() && breadCrumbs.length < maxCrumbs) {
    currentTopBox = currentTopBox.GetParent();

    if (topBoxCrumb == null) {
      breadCrumbs.unshift(currentTopBox);
    }
  }

  return breadCrumbs;
};

const getNormalizedCrumbs = (breadCrumbs, currentSubChart) => {
  if (!currentSubChart) return [];
  return breadCrumbs.map(crumb => {
    const crumbText = BoxChip.FromObjDBObject(crumb).crumbLabel();
    const targetID = crumb.GetObjectRecordID();
    return {
      name: crumbText,
      targetID: targetID,
      onClick: () => crumbClick(targetID),
      isActive: crumb === currentSubChart.fTopDBObj
    };
  });
};

const ChartBreadcrumbs = props => {
  const { maxCrumbs = 10 } = props;

  const [cachedCrumbs, setCachedCrumbs] = useState([]);
  const doc = StateLib.GetDoc();
  const subchartMgr = doc && doc.fSubChartMgr;
  const currentSubchart = subchartMgr && subchartMgr.fCurrentSubChart;

  useEffect(() => {
    const breadCrumbs = getBreadcrumbs(currentSubchart, cachedCrumbs, maxCrumbs);
    setCachedCrumbs(breadCrumbs);
    setTimeout(updateScrollPosition, 50);
  }, [currentSubchart]);

  const normalizedCrumbs = getNormalizedCrumbs(cachedCrumbs, currentSubchart);
  const updateScrollPosition = () => {
    const container = document.querySelector(".contextToolbar");
    const activeElement = document.querySelector(".ocn-breadcrumb-item--active");

    if (container && activeElement) {
      const containerRect = container.getBoundingClientRect();
      const activeElementRect = activeElement.getBoundingClientRect();

      const activeElementLeft = activeElementRect.left - containerRect.left;

      container.scroll({
        left: activeElementLeft,
        behavior: "smooth"
      });
    }
  };

  return (
    <div
      className={cx("ocn-breadcrumbs-container", "ocn-list-scrollbar")}
      data-testid="chart-mode-toolbar-breadcrumbs"
    >
      <Breadcrumb crumbs={normalizedCrumbs} />
    </div>
  );
};

ChartBreadcrumbs.propTypes = {
  /**
   * The maximum length of the breadcrumbs list
   */
  maxCrumbs: PropTypes.number
};

export default ChartBreadcrumbs;
